export enum SsbRateMode {
  WITHIN_BOX = 'within-box',
  PER_CAPITA = 'per-capita',
}
